import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/cbc514ab-4afd-42bf-873e-9ee54d0e5f6a";
export const REGISTER_URL = "https://a.ntrk2.com/fbfe19cb-a9fc-4bdc-a32a-f00d328b7508";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://yescop.kzw2a.com/download?openExternalBrowser=1&id=k6w5a8d2siaef8w";

export * from "./codes";
export * from "./context";
